import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCarrierListEffect } from '../../../../redux/shipment/ShipmentEffects';
import CarrierSearchModal from '../../../screens/common/CarrierSearchModal/CarrierSearchModal';
import IconButton from '../../Buttons/IconButton';
import SvgConverter from '../../Common/SvgConverter';
import FormSelectBox from '../../Inputs/FormSelectBox';
import { ReactComponent as ZoomIcon } from './../../../../assets/icons/zoom-input.svg';

const TransportationProviderSelector = ({
  placeholder = i18n.t('translation:default.fields.transportationProvider.selectPlaceholder'),
  label = i18n.t('translation:default.fields.transportationProvider.label'),
  rules = [],
  name,
  form = {},
  disabled = false,
  margin = 'mb-0',
  editMode = true,
  inputValue,
  defaultOptions,
  defaultValue,
  onChange = false,
  hasError = false,
  showPopupFilter = false,
  carrierName,
  disableOpen = false,
  tabIndex,
  labelForTestId,
  customerKey,
  isAllRequired = false,
  isVendor = false,
}) => {
  const [modal, setModal] = useState(false);
  const { selectedCompany } = useSelector((state) => state.auth);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allowClear, setAllowClear] = useState(!showPopupFilter);

  useEffect(() => {
    if (selectedCompany?.companyId && !isVendor) {
      getStatusList(selectedCompany.companyId);
    }
    if (isVendor && customerKey) {
      getStatusList(customerKey);
    }
  }, [selectedCompany, inputValue, customerKey]);

  const getStatusList = async (customerKey) => {
    try {
      setLoading(true);
      // TODO: use useGetCarrierList hook instead effect
      const { data } = await getCarrierListEffect({ customerKey });
      let options = data.map((row) => ({
        label: row.carrierName,
        value: row.carrierKey,
      }));
      if (isAllRequired) {
        options = [{ label: 'All', value: '0' }, ...options];
      }
      const isExist = options.find((option) => option.value === inputValue);
      if (!isExist && carrierName && inputValue) {
        options = [{ label: carrierName, value: inputValue }, ...options];
      }
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  const handleSelect = (data) => {
    const isExist = options.find(({ value }) => value === data?.carrierKey);
    if (!isExist) {
      setOptions((options) => [{ label: data?.carrierName, value: data?.carrierKey }, ...options]);
    }
    if (onChange) {
      onChange(data);
    } else {
      if (form) {
        form.setFieldValue(name, data?.carrierKey);
      }
    }
    setModal(false);
  };

  const onChangeValue = (data) => {
    setAllowClear(true);
    if (onChange) {
      onChange(data);
    }
    if (!form.getFieldValue(name)) {
      setAllowClear(false);
    }
  };
  return (
    <>
      <FormSelectBox
        disableOpen={disableOpen}
        loading={loading}
        options={options}
        placeholder={placeholder}
        label={label}
        margin={margin}
        rules={rules}
        name={name}
        editMode={editMode}
        defaultValue={defaultValue}
        value={inputValue ? inputValue : form.getFieldValue(name)}
        onClear={() => form.setFieldsValue({ [name]: undefined })}
        hasError={hasError}
        defaultOptions={defaultOptions}
        disabled={disabled}
        allowClear={allowClear}
        {...(!allowClear
          ? {
              suffixIcon: (
                <IconButton onClick={() => setModal(true)} tabIndex={disableOpen ? tabIndex : -1}>
                  <SvgConverter Icon={ZoomIcon} color="muted" />
                </IconButton>
              ),
            }
          : {})}
        onChange={onChangeValue}
        tabIndex={!disableOpen ? tabIndex : -1}
        dataTestId={labelForTestId}
      />
      <CarrierSearchModal
        open={modal}
        handleSelect={handleSelect}
        handleClose={() => setModal(false)}
        labelForTestId={labelForTestId}
      />
    </>
  );
};

export default TransportationProviderSelector;
